import { FETCH_ALL_LOCAL_AID_TYPES } from '../../constants/actionTypes'

export default (laTypes = {}, action) => {
    switch (action.type) {
        case FETCH_ALL_LOCAL_AID_TYPES:
            return action.payload;
        default:
            return laTypes;
    }
}